const parsedPrice = itemPrice => {
  if (itemPrice === 999999999) {
    return 'POA';
  } else if (!itemPrice || !itemPrice.toLocaleString) {
    return 'POA'; // NOTE: phrasing might need change, itemPrice can be null
  } else {
    return `£${itemPrice.toLocaleString('en')}`;
  }
};
export default parsedPrice;



// WEBPACK FOOTER //
// ./src/Common/parsedPrice/index.js